import { PrismLight as SyntaxHighlighter } from "react-syntax-highlighter";
import json from "react-syntax-highlighter/dist/esm/languages/prism/json";

// Tool の通常表示と仮想化表示は JSON のみを扱う。任意言語の回答は Response が担う。
SyntaxHighlighter.registerLanguage("json", json);

export default SyntaxHighlighter;
